/** @jsxImportSource @emotion/react */

import { notification } from "antd";
import { ContactApi } from "api/contact";
import Background from "assets/temporary/images/banner_deposit.png";
import Loading from "components/Common/Loading";
import { ModalCustom } from "components/Common/ModalCustom";
import { ResponseCode } from "contants/response";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { selectOpenModal, setOpenModal } from "store/modal";
import { ContactType } from "types/contact";

import { UplineContactModalStyle } from "./style";

const getContactHref = (url: string) => {
  if (!url) return undefined;

  const href = /^https?:\/\//i.test(url)
    ? url
    : `https://${url.replace(/^\/\//, "")}`;

  try {
    const parsed = new URL(href);
    return parsed.hostname && !parsed.username && !parsed.password
      ? href
      : undefined;
  } catch {
    return undefined;
  }
};

const UplineContactModal = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["message", "csBox"]);
  const [contacts, setContacts] = useState<ContactType[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const openModal = useAppSelector(selectOpenModal);
  const isOpen = openModal.includes("uplineContact");
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    if (!isOpen) return;

    let active = true;
    setIsLoading(true);
    setContacts([]);

    const loadContacts = async () => {
      try {
        const response = await ContactApi.getContact();
        if (!active) return;

        if (response.status !== ResponseCode.SUCCESS) {
          api.error({ message: response.msg });
          return;
        }

        setContacts(response.data);
      } catch {
        if (!active) return;

        api.error({
          message: t("csBox:ContactLoadError"),
        });
      } finally {
        if (active) setIsLoading(false);
      }
    };

    loadContacts();

    return () => {
      active = false;
    };
  }, [isOpen, api, t]);

  const visibleContacts = contacts.filter(
    (contact) => contact.Platform?.trim() && contact.URL?.trim()
  );

  return (
    <ModalCustom
      isOpenModal={isOpen}
      handleCloseModal={() => dispatch(setOpenModal(""))}
      titleModal={t("header:UplineContact")}
      headerBackground={Background}
      heightBackground={75}
      bodyModal={
        <div css={UplineContactModalStyle.wrapper}>
          {isLoading ? (
            <Loading height={110} center fontSize={30} />
          ) : (
            <div className="wrap-inner">
              {visibleContacts.map((contact) => (
                <div className="contact-item" key={contact.id}>
                  <span className="contact-label">
                    {contact.Platform.trim()}:
                  </span>
                  <a
                    href={getContactHref(contact.URL.trim())}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="telegram-link"
                  >
                    {contact.URL.trim()}
                  </a>
                </div>
              ))}
            </div>
          )}
          {contextHolder}
        </div>
      }
    />
  );
};
export default UplineContactModal;
